<template>
  <div class="permissions-view pa-4">
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon left dark>mdi-shield-account</v-icon>
        Gestión de Accesos
      </v-card-title>

      <v-tabs v-model="activeTab" background-color="primary" dark grow>
        <v-tab>
          <v-icon left>mdi-account-group</v-icon>
          Usuarios
        </v-tab>
        <v-tab>
          <v-icon left>mdi-account-key</v-icon>
          Perfiles de acceso
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="activeTab">
        <!-- TAB 1: USUARIOS -->
        <v-tab-item>
          <user-permissions-list />
        </v-tab-item>

        <!-- TAB 2: SUBROLES -->
        <v-tab-item>
          <role-permissions-list
            ref="subrolesList"
            @create="openRoleModal(null)"
            @edit="openRoleModal($event)"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <!-- Modal crear / editar subrol -->
    <role-setup-modal
      v-model="roleModal"
      :role-data="selectedRole"
      @save="onSaveRole"
    />
  </div>
</template>

<script>
import DefaultLayout from "@/components/layouts/DefaultLayout.vue";
import UserPermissionsList from "@/components/permissions/UserPermissionsList.vue";
import RolePermissionsList from "@/components/permissions/RolePermissionsList.vue";
import RoleSetupModal from "@/components/permissions/RoleSetupModal.vue";

export default {
  name: "AdminPermissionsView",
  components: {
    UserPermissionsList,
    RolePermissionsList,
    RoleSetupModal
  },
  data() {
    return {
      activeTab: 0,
      roleModal: false,
      selectedRole: null
    };
  },
  created() {
    this.$emit(`update:layout`, DefaultLayout);
    // Cargar la lista de contactos al inicio para que el conteo en los roles esté listo
    this.$store.dispatch("contacts/fetchContactList");
  },
  methods: {
    openRoleModal(role) {
      this.selectedRole = role; // null = Create, object = Edit
      this.roleModal = true;
    },

    onSaveRole() {
      this.$refs.subrolesList.fetchSubroles();
    }
  }
};
</script>

<style scoped>
/* Estilos globales de la UI de permisos si es necesario */
</style>
